import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { ForgotPasswordComponent } from './modules/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './modules/auth/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layouts/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/admin-layout/admin-layout.module').then(
        (m) => m.AdminLayoutModule
      ),
  },
  {
    path: 'forget-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  // {
  //   path: 'shared/machine/view/:id',
  //   canActivate: [AuthGuard],
  //   component: MachineViewDetailsComponent,
  // },
  {
    path: 'common',
    canActivate: [AuthGuard],
    loadChildren: () => import('./layouts/common-layout/common-layout.module').then(m => m.CommonLayoutModule)
  },
  {
    path: 'admin/projects/viewmode/details',
    loadChildren: () => import('./layouts/public-layout/public-layout.module').then(m => m.PublicLayoutModule)
  },
  {
    path: '**',
    loadChildren: () =>
      import('./shared/page-not-found/page-not-found.module').then(
        (m) => m.PageNotFoundModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
